module.exports = __webpack_public_path__ + "static/media/FolderRedLight.2e0bb2a3.svg";